export default "__VITE_ASSET__D9VEZcyd__"